onComplete(function () {
	document.querySelectorAll('h1, h2, h3').forEach(header => {
		const words = header.textContent.trim().split(/\s+/);

		// 4+ words = wrap first 2
		// 3 or fewer = wrap only first 1
		const wrapCount = words.length >= 4 ? 2 : 1;

		const result = words.map((word, index) => {
			return index < wrapCount
				? `<span class="header-outline">${word}</span>`
				: word;
		});

		header.innerHTML = result.join(' ');
	});

	const updateNavHeight = () => {
		const navHeader = document.querySelector('.nav-header');

		if (navHeader) {
			document.documentElement.style.setProperty(
				'--nav-height',
				`${navHeader.offsetHeight}px`
			);
		}
	};

	updateNavHeight();

	window.addEventListener('resize', updateNavHeight);
});